import React from 'react';

import styles from './LinkToDetail.module.css';

interface ILinkToDetail {
  onClick: () => void;
  content: string;
}

const LinkToDetail = ({ onClick, content }: ILinkToDetail) => (
  <button type="button" onClick={onClick} className={styles.linkToDetail}>
    {content}
  </button>
);

export default LinkToDetail;
